import React, { useEffect, useState } from 'react';

import { manualAttendanceList } from '../../API/API';
import classes from './ManualAttendance.module.scss';
import toast from 'react-hot-toast';

const ManualAttendanceList = ({ listType }) => {
    const [manualAttList, setManualAttList] = useState([]);

    const userID = localStorage.getItem('userID');
    const data = JSON.parse(localStorage.getItem('data'));

    useEffect(() => {
        if (userID !== null && data !== null) {

            manualAttendanceList(userID, data.empid, data.token, listType.toString())
                .then(response => {
                    setManualAttList(response.data)
                    // console.log(`@@RESPONSE FOR ${listType}`, response)
                })
                .catch(error => {
                    toast("Problem in Fetching Manual Attendance List",
                        {
                            icon: '❗',
                        }
                    )
                })
        }
    }, [])
    const date = new Date();
    return (
        <div className={classes.ManualAttendanceList}>
            {/* <h3>{listType === "A" ? "Approved Manual Attendance" : (listType === "R" ? "Rejected Manual Attendance" : (listType === "P" ? "Pending Manual Attendance" : ""))}</h3> */}
            {manualAttList.length > 0 || manualAttList !== null ?
                manualAttList.sort((a, b) => {
                    return b.dt.split("-")[1] - a.dt.split("-")[1]
                }).sort((a, b) => {
                    return b.dt.split("-")[2] - a.dt.split("-")[2]
                }).map(
                    ((item, index) => {
                        return (
                            <div key={index} className={classes.Info}>
                                <h4>{item.dt}</h4>
                                <div className={classes.TimeInfo}>
                                    <div>
                                        <b>In Time/Location</b><br />
                                        <p>{item.in_time}<br /></p>
                                        {item.in_from.length > 15 ? item.in_from.replace(/_/g, " ").substring(0, 10) + "..." : item.in_from.replace(/_/g, " ")}
                                    </div>
                                    <div>
                                        <b>Out Time/Location</b><br />
                                        <p>{item.out_time}<br /></p>
                                        {item.out_from.length > 15 ? item.out_from.replace(/_/g, " ").substring(0, 10) + "..." : item.out_from.replace(/_/g, " ")}
                                    </div>
                                </div>
                                <div className={classes.Remarks}>
                                    <p>
                                        {item.remarks.length > 20 ? item.remarks.substring(0, 10) + "..." : item.remarks}
                                    </p>
                                </div>
                            </div>
                        )
                    })
                ) :
                "No List to Show"
            }

        </div>
    )
}

export default ManualAttendanceList
